import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AgmMapMarker } from '../models/agmmarker';
import { AngularFireDatabase } from '@angular/fire/database';
import { AgmMapPolylinePoint } from '../models/agmpolylinepoint';
import { Polyline } from '../models/polyline';
import { ApiProvider } from '../providers/api.provider';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AgmGoogleMapService {
  private _mapmarker = new BehaviorSubject<AgmMapMarker[]>([]);
  private mappolylineSubject: BehaviorSubject<AgmMapPolylinePoint[]>;
  public mappolyline: Observable<AgmMapPolylinePoint[]>;

  public dataStore: {
    mapmarkerlist: AgmMapMarker[];
    polylinedata: AgmMapPolylinePoint[];
  };
  public AgmPolylineCoordinates: AgmMapPolylinePoint[] = [];
  public polySegments: AgmMapPolylinePoint[][] = [];
  public poly: any;

  readonly mappolylinelist = this._mapmarker.asObservable();

  public _markers: AgmMapMarker[] = [];
  public Routemarkers: Map<string, AgmMapMarker[]> = new Map();
  public markers: AgmMapMarker[] = [];
  public markers1: AgmMapMarker[] = [];

  constructor(
    private db: AngularFireDatabase,
    private zone: NgZone,
    private apiProvider: ApiProvider
  ) {
    // console.log(this.baseUrl);
    this.dataStore = { mapmarkerlist: [], polylinedata: [] };
    this._mapmarker = new BehaviorSubject<AgmMapMarker[]>(null);
    this.mappolylineSubject = new BehaviorSubject<AgmMapPolylinePoint[]>(null);
  }

  public get currentAgmMapPolylineValue(): AgmMapPolylinePoint[] {
    return this.mappolylineSubject.value;
  }

  public loadAll(routeid: Number) {
    this.GetDataFromDataBase(routeid);
    this.dataStore.mapmarkerlist = this.markers1;
    this._mapmarker.next(Object.assign({}, this.dataStore).mapmarkerlist);
  }

  public ClearMap(routeid: Number) {
    this.GetDataFromDataBase(routeid);
  }

  /* The following function Gets the markers for a route from firebase
   **/
  public GetDataFromDataBase(routeid: any) {
    this.markers1 = [];
    this.AgmPolylineCoordinates = [];
    this.polySegments = [];
    this.poly = null;
    this.apiProvider.GetRouteePolyline(routeid).subscribe(
      (polylinestring: string) => {
        this.setPolyline(polylinestring);
      },
      (err: HttpErrorResponse) => {}
    );
  }

  public setPolyline(polyline: string, herePolyline?: string) {
    if (herePolyline && herePolyline.trim().length > 0) {
      polyline = herePolyline;
    }
    if (polyline != null && polyline.length > 0) {
      const polylineobject = new Polyline(polyline);
      this.polySegments = polylineobject.decodepolylineSegments();
      this.poly = this.polySegments.reduce((points, segment) => points.concat(segment), []);
    } else {
      this.poly = null;
      this.polySegments = [];
    }
  }
  /**
   * Add Stops to map
   */
  public AddMarkerToArray(Stopinfo: any): any {
    // const latLng = new google.maps.LatLng(Stopinfo.Latitude, Stopinfo.Longitude);
    const seq = '' + Stopinfo.Sequence;
    let newmarker: AgmMapMarker = new AgmMapMarker();
    newmarker = this.CreateMarker(Stopinfo);
    this.markers1.push(newmarker);
    // this.changeDetector.detectChanges();
    if (seq) {
      return newmarker;
    }
  }

  private snapshotToArray(snapshot) {
    const returnArr = [];

    snapshot.forEach(function (childSnapshot) {
      const item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  }

  // Check If marker Exist.
  private UpdateMarkerInfo(currentmarker: any): number {
    let index: number = -1;
    let Existing: boolean = false;
    const currentmarkerid: number = currentmarker.val().MarkerID;
    for (let i = 0; i < this.markers1.length; i++) {
      if (this.markers1[i].markerid === currentmarkerid) {
        index = i;
        //this.markers1.splice(i,1);
        //console.log('update marker:' + currentmarkerid);
        this.markers1[i] = this.UpdateMarker(currentmarker);
      }
    }
    return index;
  }

  private RemoveMarker(currentmarker: any): number {
    let index: number = -1;
    let Existing: boolean = false;
    const currentmarkerid: number = currentmarker.val().MarkerID;
    for (let i = 0; i < this.markers1.length; i++) {
      if (this.markers1[i].markerid === currentmarkerid) {
        index = i;
        //console.log('removed marker:' + currentmarkerid);
        this.markers1.splice(i, 1);
      }
    }
    return index;
  }
  private CreateMarker(Stopinfo: any): AgmMapMarker {
    const newmarker: AgmMapMarker = new AgmMapMarker();
    newmarker.name = String(Stopinfo.Name);
    newmarker.markerid = Number(Stopinfo.MarkerID);
    newmarker.consolid = Number(Stopinfo.ConsolID);
    newmarker.lat = Number(Stopinfo.Latitude);
    newmarker.lng = Number(Stopinfo.Longitude);
    newmarker.label = String(Stopinfo.Sequence);
    newmarker.address = String(Stopinfo.Address);
    newmarker.postalcode = String(Stopinfo.postalcode);
    newmarker.status = String(Stopinfo.status);
    newmarker.forecastdeliverydate = String(Stopinfo.ForecastDeliveryDate);
    newmarker.note = String(Stopinfo.note);
    newmarker.draggable = false;
    let markerimg: string = 'assets/images/Spot_Icon.png';
    let statustext: string = '';
    if (Stopinfo.status === 0) {
      markerimg = 'assets/images/markerreceived.png';
      statustext = 'Donnée reçues';
    }
    if (Stopinfo.status === 1) {
      markerimg = 'assets/images/markerinroute.png';
      statustext = 'En transit';
    }
    if (Stopinfo.status === 2) {
      markerimg = 'assets/images/markerinroute.png';
      statustext = 'En route';
    }
    if (Stopinfo.status === 3) {
      markerimg = 'assets/images/markerfailed.png';
      statustext = 'Incomplet';
    }
    if (Stopinfo.status === 4) {
      markerimg = 'assets/images/markersuccess.png';
      statustext = 'Complétée';
    }
    if (Stopinfo.status === 5) {
      markerimg = 'assets/images/markerfailed.png';
      statustext = 'Supprimée';
    }
    if (!Stopinfo.Served) {
      markerimg = 'assets/images/markerfailed.png';
    }
    newmarker.iconurl = markerimg;
    newmarker.status = statustext;
    return newmarker;
  }

  private UpdateMarker(Stopinfo: any): AgmMapMarker {
    const newmarker: AgmMapMarker = new AgmMapMarker();
    newmarker.name = String(Stopinfo.val().Name);
    newmarker.markerid = Number(Stopinfo.val().MarkerID);
    newmarker.consolid = Number(Stopinfo.val().ConsolID);
    newmarker.lat = Number(Stopinfo.val().Latitude);
    newmarker.lng = Number(Stopinfo.val().Longitude);
    newmarker.label = String(Stopinfo.val().Sequence);
    newmarker.address = String(Stopinfo.val().Address);
    newmarker.postalcode = String(Stopinfo.val().postalcode);
    newmarker.status = String(Stopinfo.val().status);
    newmarker.forecastdeliverydate = String(
      Stopinfo.val().ForecastDeliveryDate
    );
    newmarker.note = String(Stopinfo.val().note);
    newmarker.draggable = false;
    let markerimg: string = 'assets/images/Spot_Icon.png';
    let statustext: string = '';
    if (Stopinfo.val().status === 0) {
      markerimg = 'assets/images/markerreceived.png';
      statustext = 'Donnée reçues';
    }
    if (Stopinfo.val().status === 1) {
      markerimg = 'assets/images/markerinroute.png';
      statustext = 'En transit';
    }
    if (Stopinfo.val().status === 2) {
      markerimg = 'assets/images/markerinroute.png';
      statustext = 'En route';
    }
    if (Stopinfo.val().status === 3) {
      markerimg = 'assets/images/markerfailed.png';
      statustext = 'Incomplet';
    }
    if (Stopinfo.val().status === 4) {
      markerimg = 'assets/images/markersuccess.png';
      statustext = 'Complétée';
    }
    if (Stopinfo.val().status === 5) {
      markerimg = 'assets/images/markerfailed.png';
      statustext = 'Supprimée';
    }
    if (!Stopinfo.val().Served) {
      markerimg = 'assets/images/markerfailed.png';
    }
    newmarker.iconurl = markerimg;
    newmarker.status = statustext;
    return newmarker;
  }
}
